// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { MASTER_URL, MASTER_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { BranchIndex } = lazily(() => import('pages/back-office/master/branch'))

const branchRoutes: IRoute[] = [
  {
    path: MASTER_URL.BRANCH,
    component: BranchIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: MASTER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'masterBranch.branch',
        accessCodes: [992],
      },
    },
  },
]

export { branchRoutes }
